/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const microphone = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.773 11.733V15M3 5.667v1.596c.03 1.21.55 2.36 1.444 3.197a4.748 4.748 0 0 0 3.329 1.273A4.748 4.748 0 0 0 11.1 10.46a4.54 4.54 0 0 0 1.444-3.197V5.667M7.774 15h2.545m-2.545 0H5.227M7.79 1c1.315 0 2.38 1.042 2.38 2.327v3.466c0 1.285-1.065 2.327-2.38 2.327-1.314 0-2.38-1.042-2.38-2.327V3.327C5.41 2.042 6.476 1 7.79 1Z"
    />
  </svg>
)
export default microphone
